import { useCallback, useMemo, useState } from 'react';
import PaymentsPopup from '../Payments/PaymentsPopup';
import { getString } from '../../../strings';
import { StyledText } from '../../atoms/Text/StyledText';
import { StyledButton } from '../../atoms/Button/StyledButton';
import { BigLoader, StyledBigLoader } from '../../atoms/Loader/StyledBigLoader';
import { updatePlaces, uploadLogo } from '../../../logic/requests/events';
import { StyledInputsDivWrapper } from '../../atoms/StyledInputsDivWrapper/StyledInputsDivWrapper';
import { StyledInputWrapper } from '../../../styles/sharedStyles';
import { StyledCustomFile } from '../../molecules/UserPanelReqElementTrainer/UserPanelReqElementTrainer.styles';
import { useQueryClient } from '@tanstack/react-query';

const UpdateLogoPopup = ({ eventData, onClose }) => {
    const [logo, setLogo] = useState();
    const [fileName, setFileName] = useState('');
    const [error, setError] = useState(null);
    const [queryFinished, setQueryFinished] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const queryClient = useQueryClient();

    const onSubmit = useCallback(() => {
        setIsLoading(true);
        const formData = new FormData();
        formData.append('logo', logo);

        uploadLogo(eventData.id, formData).then(
            (res) => {
                setError(null);
            },
            (err) => {
                setError(err);
                console.log(err);
            }
        ).finally(() => {
            queryClient.invalidateQueries(['allEvents']);
            setQueryFinished(true);
            setIsLoading(false);
        });
        
    }, [eventData, logo]);

    const handleFileUpload = useCallback((e) => {
        const file = e.target.files?.[0];
    
        if (!file) {
            setLogo(null);
            setFileName('');
            return;
        }
    
        setLogo(file);
        setFileName(file.name);
    }, []);

    const renderContent = useMemo(
        () =>
            queryFinished ? (
                <div>
                    {error ? (
                        <>
                            <StyledText
                                hasdeclaredfontsize="20px"
                                hasdeclaredpadding={'50px 20px 20px 20px'}
                                hasdeclaredlineheight="1.4em"
                                hasdeclaredtextalign="center"
                                hasdeclaredfontcolor="#EE745C"
                                hasdeclaredfontweight="600"
                            >
                                {getString('userPanel_userPanelTournament_upload_logo_error')}
                            </StyledText>
                            <StyledText
                                hasdeclaredfontsize="18px"
                                hasdeclaredpadding={'20px 20px 20px 20px'}
                                hasdeclaredlineheight="1.4em"
                                hasdeclaredtextalign="center"
                            >
                                {error.data.message}
                            </StyledText>
                        </>
                    ) : (
                        <StyledText
                            hasdeclaredfontsize="18px"
                            hasdeclaredpadding={'50px 20px 20px 20px'}
                            hasdeclaredlineheight="1.4em"
                            hasdeclaredtextalign="center"
                        >
                            {getString('userPanel_userPanelTournament_upload_logo_success')}
                        </StyledText>
                    )}
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onClose}
                        >
                            {getString('all_trainer_pay_popup_zamknij')}
                        </StyledButton>
                    </div>
                </div>
            ) : isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <BigLoader />
                </div>
            ) : (
                <>
                    <StyledText
                        hasdeclaredfontsize="18px"
                        hasdeclaredpadding={'40px 20px 20px 20px'}
                        hasdeclaredlineheight="1.4em"
                        hasdeclaredtextalign="center"
                    >
                        {getString('userPanel_userPanelTournament_upload_logo_title')}
                    </StyledText>

                    <StyledInputsDivWrapper>
                        <StyledInputWrapper
                            $isCenter
                            $hasGap="8px"
                            style={{ flexDirection: 'column' }}
                        >
                            <StyledCustomFile
                                $hasDeclaredWidth="100%"
                                $hasDeclaredHeight="50px"
                                file={Boolean(logo)}
                            >
                                <label htmlFor="upload">
                                    {getString('userPanel_userPanelTournament_upload_logo_button')}
                                </label>
                                <input
                                    id="upload"
                                    type="file"
                                    onChange={handleFileUpload}
                                    style={{ display: 'none' }}
                                    accept=".svg"
                                />
                            </StyledCustomFile>
                            {fileName ? (
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredfontweight="700"
                                    hasdeclaredtexttransform="uppercase"
                                    hasdeclaredlineheight="1.4em"
                                >
                                    {fileName}
                                </StyledText>
                            ) : (
                                <StyledText
                                    hasdeclaredfontsize="16px"
                                    hasdeclaredtextalign="center"
                                    hasdeclaredfontweight="700"
                                    hasdeclaredtexttransform="uppercase"
                                    hasdeclaredlineheight="1.4em"
                                >
                                    {getString('userPanel_userPanelTournament_upload_logo_no_file_text')}
                                </StyledText>
                            )}
                        </StyledInputWrapper>
                    </StyledInputsDivWrapper>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#6d85ba"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 0 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            hasdeclaredtexttransform="uppercase"
                            onClick={onSubmit}
                        >
                            {getString('userPanel_userPanelTournament_sync_registrations_confirm')}
                        </StyledButton>
                        <StyledButton
                            hasdeclaredfontcolor="#fff"
                            hasdeclaredbgcolor="#ee745c"
                            hasdeclaredtextalign="center"
                            hasdeclaredcursor="pointer"
                            hasdeclaredwidth="150px"
                            hasdeclaredheight="50px"
                            hasdeclaredfontsize="20px"
                            hasdeclaredborderradius="35px"
                            hasdeclaredmargin="20px 0 40px 0"
                            hasdeclaredfontweight="600"
                            whileTap={{ scale: 0.9 }}
                            whileHover={{ scale: 1.05 }}
                            onClick={onClose}
                        >
                            {getString('userPanel_userPanelTournament_payment_reminder_cancel')}
                        </StyledButton>
                    </div>
                </>
            ),
        [onClose, isLoading, onSubmit, error, queryFinished]
    );

    return <PaymentsPopup>{renderContent}</PaymentsPopup>;
};

export default UpdateLogoPopup;
